interface V3IconPlusProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconPlus = ({ stroke = "#ABB0BA" }: V3IconPlusProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 3v10M3 8h10" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
